interface GlobResult {
  [key: string]: () => Promise<any>;
}

const pathHandler = (obj: GlobResult, prefix: string) => {
  const keys = Object.keys(obj);
  const res: GlobResult = {};
  for (const key of keys) {
    const newKey = key.replace(prefix, '').split('.')[0];
    res[newKey] = obj[key];
  }
  return res;
};

export const fallbacks = pathHandler(
  import.meta.glob(`/src/router/fallbacks/*.tsx`, { eager: true, import: 'default' }),
  '/src/router/fallbacks/'
);

export const layouts: Record<string, () => Promise<any>> = pathHandler(
  import.meta.glob(`/src/router/layouts/*.tsx`),
  '/src/router/layouts/'
);
export const errors: Record<string, () => Promise<any>> = {
  default: () => import('@/router/errorBoundarys/default.tsx')
};

export const pages = import.meta.glob(`/src/pages/**/*.tsx`);
const getPages = () => {
  const obj = pathHandler(pages, '/src/pages');
  return Object.keys(obj).map(key => ({ label: key, value: key }));
};

export const PAGE_LIST = getPages();

export const LAYOUT_LIST = Object.keys(layouts).map(key => ({ label: key, value: key }));
export const FALLBACK_LIST = Object.keys(fallbacks).map(key => ({ label: key, value: key }));
export const ERROR_BOUNDARY_LIST = Object.keys(errors).map(key => ({ label: key, value: key }));
